import { createContext } from "react";

export const SelectedProductContext = createContext(null);
export const SelectedLanguageContext = createContext(null);
